import "../../styles/Auth.scss"

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, setPersistence, browserSessionPersistence } from "firebase/auth"
import { logEvent } from "firebase/analytics";
import { auth, analytics } from "../../firebase-config";
import {setBackgroundImage, Toasts} from "../../helpers/helpers";
import {generateFirebaseAuthErrorMessage} from "./errorHandler";
import { ReactComponent as Logo } from "../../assets/logo.svg"

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleLogin = async () => {
        if (!email || !password) {
            Toasts.error("Please fill in all fields.");
            return;
        }

        try {
            await setPersistence(auth, browserSessionPersistence);
            await signInWithEmailAndPassword(auth, email, password);
            logEvent(analytics, 'login');
        } catch (error: any) {
            console.error(error);
            generateFirebaseAuthErrorMessage(error);
        }
    }

    document.onkeydown = function (e) {
        if (e.key === "Enter") {
            handleLogin();
        }
    };

    setBackgroundImage('');

    return (
        <div className="login-container">
            <Logo className="logo" onClick={() => navigate("/")} />
            <div className="inputs">

                <input
                    type="email"
                    id="email"
                    className="login-input"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}>
                </input>

                <input
                    type="password"
                    id="password"
                    className="login-input"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}>
                </input>

                <button className="submit-button" onClick={handleLogin}>Login</button>
                <div className="signup-text">Don't have an account? <Link to="/register">Sign Up</Link></div>
            </div>
        </div>
    )
}

export default Login;